export default __webpack_public_path__ + "9750acd36c318af22711af1e49cfc36b.png";